module.exports = __webpack_public_path__ + "static/media/bonus-modal.5cda38a5.png";